import React from "react";
import { Hero } from "../../..";
import { heroData } from "../../../../assets/data/aboutUsData";

export default function AboutUsHero(props) {
	return <Hero data={heroData} />;
}
